import { render, staticRenderFns } from "./GestionBodegaInstitucion.vue?vue&type=template&id=732d217f&scoped=true"
import script from "./GestionBodegaInstitucion.vue?vue&type=script&lang=js"
export * from "./GestionBodegaInstitucion.vue?vue&type=script&lang=js"
import style0 from "./GestionBodegaInstitucion.vue?vue&type=style&index=0&id=732d217f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d217f",
  null
  
)

export default component.exports